import type { BackgroundRemovalProgress } from '../../backgroundRemoval/imageModalBackgroundRemovalProgressTypes';

export const IMAGE_MODAL_V2_OPERATION_MESSAGE = {
    REMOVING_BACKGROUND: 'removingBackground',
    SAVING_CHANGES: 'savingChanges',
} as const;

export type ImageModalV2OperationMessage =
    (typeof IMAGE_MODAL_V2_OPERATION_MESSAGE)[keyof typeof IMAGE_MODAL_V2_OPERATION_MESSAGE];

export type ImageModalV2OperationToastState = {
    message: ImageModalV2OperationMessage;
    progress: BackgroundRemovalProgress | null;
};
